<template>
    <div class="content-frame-open-close">
        <div class="content-frame-open-close-top" :style="colorComponent()" @click="openClose">
            <div class="content-frame-open-close-top-title">{{ title }}</div>
            <div class="content-frame-open-close-top-button" :class="{ open: openDialog, close: !openDialog }"></div>
        </div>
        <div class="content-frame-open-close-content" v-show="openDialog"><slot></slot></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        open: { type: Boolean, default: true },
        title: { type: String, default: "" },
        canChangeColor: { type: Boolean, default: false }
    },
    data() {
        return {
            openDialog: false
        };
    },
    computed: {
        ...mapGetters("planonext/carcass/", {
            getComponentSelected: "getComponentSelected"
        })
    },
    created() {
        this.openDialog = this.open;
    },
    mounted() {},
    methods: {
        openClose() {
            this.openDialog = !this.openDialog;
        },
        colorComponent() {
            // console.log('color')
            if (this.canChangeColor) {
                if (this.getComponentSelected) {
                    return "background-color: " + this.getComponentSelected._color;
                }
            }
            return "";
        }
    }
};
</script>

<style scoped lang="scss">
.content-frame-open-close {
    width: 100%;
    border: 1px solid #b3b3b1;
    border-radius: 10px;
    /* overflow: hidden; */
    margin-bottom: 5px;
    background-color: #ffffff;
    .content-frame-open-close-top {
        border-radius: 10px 10px 0px 0px;
        border-bottom: #b3b3b1 1px solid;
        // height: 50px;
        padding: 10px 5px;
        background-color: #ccccc9;
        position: relative;
        .content-frame-open-close-top-title {
            color: #fff;
            /*font-weight: bold;*/
            font-family: Oswald, Sans-Serif;
            font-size: 16px;
        }

        .content-frame-open-close-top-button {
            position: absolute;
            right: 5px;
            width: 10px;
            height: 10px;
            top: 5px;
            margin: 5px 4px;
            /*background-color: #FFFFFF;*/
        }

        .open {
            background: url("../../../assets/arrow-down.svg") no-repeat;
        }

        .close {
            background: url("../../../assets/arrow-up.svg") no-repeat;
            /*background-repeat: no-repeat;*/
        }
    }
    .content-frame-open-close-content {
        padding: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// FrameOpenClose.vue?1d7915b8